module.exports = __webpack_public_path__ + "static/img/zhiding.ce1a97bd.png";